import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip, { RIGHT, ERROR } from '../tooltip/Tooltip';

import s from './IconMenu.module.scss';

export default class IconMenu extends Component {
    static propTypes = {
        isV5: PropTypes.bool,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                onSelect: PropTypes.func.isRequired,
                icon: PropTypes.string,
            }),
        ),
    };

    static defaultProps = { isV5: true, options: [] };

    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    onSelectOption = fn => {
        fn();
        this.setState({ open: false });
    };

    renderOption = ({ label, onSelect, icon }) => {
        const clickHandler = () => {
            this.setState({ open: false });
            onSelect();
        };

        return (
            <div key={label} onClick={clickHandler} className={s.option}>
                {icon && <span className={classNames(icon, s.optionIcon)} />}
                <span className={s.optionLabel}>{label}</span>
            </div>
        );
    };

    renderDropdown = (options, open) => (
        <div className={classNames(s.iconMenu)}>
            <div className="icon-submenu" onClick={() => this.setState({ open: !open })} />
            <div className={classNames(s.optionsWrapper, { [s.open]: open })}>{options.map(this.renderOption)}</div>
        </div>
    );

    renderTrashcan = ({ onSelect }) => (
        <button className={classNames('icon-trash', s.headerIcons, s.trashIcon)} onClick={() => onSelect()} type="button" data-testid="remove-poi-button">
            <Tooltip arrowPosition={RIGHT} type={ERROR} text="Remove POI" />
        </button>
    );

    render() {
        const { isV5, options } = this.props;
        const { open } = this.state;

        return isV5 ? this.renderTrashcan(options[0]) : this.renderDropdown(options, open);
    }
}
